module.exports = __webpack_public_path__ + "static/media/americanExpressIcon4.5758ebdd.png";